/** Build identity baked in at deploy time via Vite. */
export function getAppBuild() {
  return {
    id: import.meta.env.VITE_APP_BUILD_ID || 'dev',
    sha: import.meta.env.VITE_APP_BUILD_SHA || 'dev',
    builtAt: import.meta.env.VITE_APP_BUILT_AT || '',
  };
}

export function formatBuildTooltip(id) {
  return id ? `Version ${id}` : 'Development build';
}
